module.exports = __webpack_public_path__ + "static/media/mns-affiliate-map.3c8292e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/mnsmap/mns-affiliate-map.png
// module id = 56
// module chunks = 0